import * as React from "react";

interface SafeIframeProps {
  iframeHtml: string;
}

const SafeIframe: React.FC<SafeIframeProps> = ({ iframeHtml }) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(iframeHtml, 'text/html');
  const iframe = doc.querySelector('iframe');
  
  if (!iframe) return null;
  
  const src = iframe.getAttribute('src');
  if (!src || !src.includes('youtube.com/embed/')) return null;
  
  // Safely extract title attribute
  const title = iframe.getAttribute('title') || 'YouTube video player';
  
  return (
    <iframe
      src={src}
      width="100%"
      height="400"
      frameBorder="0"
      allowFullScreen
      sandbox="allow-scripts allow-same-origin"
      title={title}
    />
  );
};

export default SafeIframe;